import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IMenuStore,
} from '../../mobx-store/storeInterfaces/menuCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  menuStore: IMenuStore;
  countryStore: CountryStore;
  history: any;
  match: any;
}

@inject('menuStore')
@inject('countryStore')
@observer
class MenuManagement extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  categoryId: number;

  restaurantId: number;

  constructor(props: IProps) {
    super(props);
    this.title = translate('menuListPageTitle', {
    });
    this.categoryId = this.props.match.params.categoryId;
    this.restaurantId = this.props.match.params.restaurantId;
    console.log(this.categoryId);
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.menuStore.updateMenuStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/restaurants/${this.restaurantId}/categories/${this.categoryId}/menus/${this.props.menuStore.menuList[index].mealId}/edit`,
    );
  };

  handleTableItemsButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/restaurants/${this.restaurantId}/categories/${this.categoryId}/menus/${this.props.menuStore.menuList[index].mealId}/Items`,
    );
  };

  handelAdd = (): void => {
    this.props.history.push(`/restaurants/${this.restaurantId}/categories/${this.categoryId}/menus/new`);
  };

  getAddMenuButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getMenuTableHeader = () => [
    {
      title: translate('menuListCategoryColumnTitle', {
      }),
    },
    {
      title: translate('menuListPriceColumnTitle', {
      }),
    },
    {
      title: translate('menuListStatusColumnTitle', {
      }),
    },
    {
      title: translate('menuListEditColumnTitle', {
      }),
    },
  ];

  getMenuTableData = () => this.props.menuStore.menuList
    .map((menu) => ({
      ...menu,
      items: translate('menuListItemsButton', {
      }),
      edit: translate('menuListEditButton', {
      }),
    }));

  getMenuTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'titleEn',
    },
    {
      cellType: 'Text',
      key: 'price',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('menuListStatusActive', {
      }),
      inactiveLabel: translate('menuListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddMenuButton();
    this.tableHeader = this.getMenuTableHeader();
    this.tableData = this.getMenuTableData();
    this.tableCellTypes = this.getMenuTableCellTypes();
    console.log(this.props.menuStore.menuList);
    return (
      <div>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.title} />
        <GeneralTableComponent
          emptyMessage={translate('menuListNoCategoriesMessage', {
          })}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.menuStore.getMenuCategoriesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, menuStore,
    } = this.props;
    await countryStore.getUserManagedCountries();

    menuStore.getMenus(this.categoryId, countryStore.managedCountries, languageCodes.english);
  }
}

export default MenuManagement;
